import primaryComponents from "../../../primaryComponents";
import Validation from "./Validation";
import useExpensesAccountSettings from "./useExpensesAccountSettings";
import styles from "../../../../pages/appPages/Accounting/AccountSettings/styles.module.scss";

const ExpensesAccountSettings = ({
  filterAccountBySubAccountType,
  findAccountMapping,
  updateAccountMappingMutation,
  handleAccountMappingSubmit,
}) => {
  const { expensesAccountMapping, setExpensesAccountMapping } =
    useExpensesAccountSettings(findAccountMapping);
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = Validation({ expensesAccountMapping });
  return (
    <form className="p-3" onSubmit={handleSubmit(handleAccountMappingSubmit)}>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Default Expense Account</h5>
          <span>The primary expense account where expenses are recorded</span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("operating_expenses")}
            control={control}
            name="expense_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("expense_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setExpensesAccountMapping((prev) => ({
                ...prev,
                expense_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.expense_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>Accounts Payable</h5>
          <span>
            Liability account for tracking unpaid bills and invoice from vendors
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("accounts_payable")}
            control={control}
            name="account_payable_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("account_payable_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setExpensesAccountMapping((prev) => ({
                ...prev,
                account_payable_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.account_payable_account}
          />
        </div>
      </div>
      <div className={`${styles["accounting__mapping"]}`}>
        <div className={`${styles["accounting__mapping__left"]}`}>
          <h5>POS Fees Account</h5>
          <span>
            Expense account for transaction charges deducted by payment
            processors on sales
          </span>
        </div>
        <div className={`${styles["accounting__mapping__right"]}`}>
          <primaryComponents.SelectFieldV2
            options={filterAccountBySubAccountType("operating_expenses")}
            control={control}
            name="pos_fee_account"
            isRequired={true}
            nameKey="account_label"
            value={
              findAccountMapping("pos_fee_account")?.chart_account
                ?.account_label || "Select chart account"
            }
            onChange={(value) => {
              setExpensesAccountMapping((prev) => ({
                ...prev,
                pos_fee_account: value,
              }));
            }}
            idKey={"id"}
            errorMessage={errors.pos_fee_account}
          />
        </div>
      </div>

      <div className="d-flex justify-content-end mt-3">
        <primaryComponents.Button
          classNames={"btn btn--primary"}
          type="submit"
          isDisabled={updateAccountMappingMutation.isLoading}
          isLoading={updateAccountMappingMutation.isLoading}
          loadingText={"Updating..."}
        >
          Save Changes
        </primaryComponents.Button>
      </div>
    </form>
  );
};
export default ExpensesAccountSettings;
